import { Link, Typography } from '@mui/material';
import { StepBox } from './TaskStepCard';
import { fileWord, waitingFileLine, waitingVideoLine } from './taskUi';

/** A task with no file behind it yet: one line and one link. The main button is pinned below. */
const TaskWaitingCard = ({ task, plan, canManage, planned, onLink }) => {
    const word = fileWord(task.contentType);
    const line =
        canManage && plan
            ? task.contentType === 'VIDEO'
                ? waitingVideoLine(plan, task)
                : waitingFileLine(plan, task.contentType)
            : null;
    return (
        <StepBox heading={canManage || planned ? 'Your step' : null} title={`Waiting for its ${word}`} line={line}>
            {canManage && plan && !plan.linkedContentId && (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    Already in AmrutVaani?{' '}
                    <Link component="button" variant="body2" onClick={onLink}>
                        Link {word}
                    </Link>
                </Typography>
            )}
        </StepBox>
    );
};

export default TaskWaitingCard;
